import BaseController from "controllers/base"

class Controller extends BaseController {
  call() {
    super.call();

    console.log("External Project Controller")

  }
};

export default Controller;
